export const NAME_VALIDATIONS = [
  {
    validate: data => {
      return data.length > 0;
    },
    message: 'Name cannot be empty.',
  },
  {
    validate: data => {
      return data.length <= 255;
    },
    message: 'Name cannot be longer than 255 characters.',
  },
];

export const GENDER_OPTIONS = [
  { value: 'na', display: 'N/A' },
  { value: 'male', display: 'Male' },
  { value: 'female', display: 'Female' },
  { value: 'other', display: 'Other' },
];

export const COURSE_VALIDATIONS = [
  {
    validate: data => {
      return data.length > 0;
    },
    message: 'Home Course cannot be empty.',
  },
  {
    validate: data => {
      return data.length <= 255;
    },
    message: 'Home Course cannot be longer than 255 characters.',
  },
];



// WEBPACK FOOTER //
// ./src/subscription/profile/profile-constants.js